<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_325" data-name="Group 325" transform="translate(-594.988 -280.286)">
    <circle id="Ellipse_70" data-name="Ellipse 70" cx="35.201" cy="35.201" r="35.201" transform="translate(594.988 280.286)" fill="#fff"/>
    <g id="Group_78" data-name="Group 78" transform="translate(-1133.858 -850.394)">
      <path id="Path_177" data-name="Path 177" d="M1765.672,1176.5c-5.7,0-10.32-1.484-10.32-3.583v3.049c0,2.1,4.621,3.8,10.32,3.8s10.32-1.7,10.32-3.8v-3.049C1775.992,1175.018,1771.372,1176.5,1765.672,1176.5Z" fill="#1a1818"/>
      <path id="Path_178" data-name="Path 178" d="M1765.672,1182.246c-5.7,0-10.32-1.484-10.32-3.583v3.049c0,2.1,4.621,3.8,10.32,3.8s10.32-1.7,10.32-3.8v-3.049C1775.992,1180.762,1771.372,1182.246,1765.672,1182.246Z" fill="#1a1818"/>
      <path id="Path_179" data-name="Path 179" d="M1765.672,1187.99c-5.7,0-10.32-1.484-10.32-3.583v3.049c0,2.1,4.621,3.8,10.32,3.8s10.32-1.7,10.32-3.8v-3.049C1775.992,1186.506,1771.372,1187.99,1765.672,1187.99Z" fill="#1a1818"/>
      <path id="Path_180" data-name="Path 180" d="M1765.672,1174.046c5.7,0,10.32-1.7,10.32-3.8s-4.62-3.8-10.32-3.8-10.32,1.7-10.32,3.8S1759.973,1174.046,1765.672,1174.046Z" fill="#1a1818"/>
    </g>
    <g id="Group_79" data-name="Group 79" transform="translate(-1133.858 -850.394)">
      <path id="Path_181" data-name="Path 181" d="M1754.393,1169.285c-5.7,0-10.319-1.484-10.319-3.583v3.049c0,2.1,4.621,3.8,10.319,3.8h0v-3.268Z" fill="#1a1818"/>
      <path id="Path_182" data-name="Path 182" d="M1754.393,1166.5c5.7,0,10.32-1.7,10.32-3.8v-3.049c0,2.1-4.62,3.583-10.32,3.583s-10.319-1.484-10.319-3.583v3.049C1744.074,1164.8,1748.695,1166.5,1754.393,1166.5Z" fill="#1a1818"/>
      <path id="Path_183" data-name="Path 183" d="M1754.393,1175.029c-5.7,0-10.319-1.484-10.319-3.583v3.049c0,2.1,4.621,3.8,10.319,3.8h0v-3.268Z" fill="#1a1818"/>
      <path id="Path_184" data-name="Path 184" d="M1754.393,1180.773c-5.7,0-10.319-1.484-10.319-3.583v3.049c0,2.1,4.621,3.8,10.319,3.8h0v-3.268Z" fill="#1a1818"/>
      <path id="Path_185" data-name="Path 185" d="M1754.393,1160.476c5.7,0,10.32-1.7,10.32-3.8s-4.62-3.8-10.32-3.8-10.319,1.7-10.319,3.8S1748.695,1160.476,1754.393,1160.476Z" fill="#1a1818"/>
    </g>
    <path id="Path_186" data-name="Path 186" d="M1771.176,1141.881a11.049,11.049,0,1,0,11.048,11.048A11.048,11.048,0,0,0,1771.176,1141.881Zm6.485,15.773-1.761,1.761-4.724-4.724-4.724,4.724-1.761-1.761,4.724-4.725-4.724-4.724,1.761-1.761,4.724,4.724,4.724-4.724,1.761,1.761-4.724,4.724Z" transform="translate(-1133.858 -850.394)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_04_01',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_04_01.vue